import React, { useState } from 'react';
import { IoChevronDownOutline, IoChevronUpOutline } from 'react-icons/io5';

import styles from './collapse.module.scss';
import '../../theme/global.scss';

import 'antd/dist/antd.css';
import { Skeleton } from 'antd';

const CCollapseInstitution = (props: any) => {
  const [opened, setOpened] = useState(false);
  const { institution } = props;

  const handleSwitch = () => {
    setOpened(op => !op);
  };

  if (!institution || institution!.id === 0) {
    return <Skeleton active />;
  } else
    return (
      <div className={styles.cardInstitution}>
        <div className={styles.textCardInstitution} onClick={handleSwitch}>
          {props.title}
          <button className={styles.switch}>
            {props.details}{' '}
            {opened ? <IoChevronUpOutline /> : <IoChevronDownOutline />}
          </button>
        </div>
        {opened && <div className={styles.details}>{props.children}</div>}
      </div>
    );
};

export default CCollapseInstitution;
